import { ReactComponent as NotesIcon } from "../assets/notes.svg";
import { ReactComponent as ProgressCircleIcon } from "../assets/progress-circle.svg";
import { ReactComponent as HabitsIcon} from "../assets/habits.svg";
import { ReactComponent as ToDoIcon } from "../assets/todo.svg";
import { ReactComponent as TasksIcon } from "../assets/tasks.svg";
import { ReactComponent as BoardsIcon } from "../assets/boards.svg";
import { ReactComponent as SettingsIcon } from "../assets/settings.svg";
import { ReactComponent as BudgetIcon } from "../assets/budget.svg";

export default function TabIcon({name=''}) {

    let icon = <NotesIcon />; 

    switch(name) {
        case 'notes': 
            icon = <NotesIcon />; 
            break;
        case 'progress-circle': 
            icon = <ProgressCircleIcon />; 
            break;
        case 'habits': 
            icon = <HabitsIcon />; 
            break;
        case 'todo': 
            icon = <ToDoIcon />; 
            break;
        case 'tasks':
            icon = <TasksIcon/>;
            break;
        case 'boards':
            icon = <BoardsIcon/>;
            break;
        case 'settings':
            icon = <SettingsIcon/>;
            break;
        case 'budget': 
            icon = <BudgetIcon/>;
            break;
        default: 
            icon = <NotesIcon />; 
            break;
    }

    const nameClass = `tab-icon--${name}`;

    return (
        <div className={`tab-icon icon icon--molding ${nameClass}`}>
            {icon}
        </div>
    );
}